import React from "react";

const CheckoutItemSkeleton: React.FC = () => {
  return [1, 2].map((item) => {
    return (
      <>
        <div key={item} className="flex gap-2 mb-3 w-full max-sm:hidden">
          <div className="skeleton min-w-28 h-36"></div>
          <div className="h-36 w-full">
            <div className="skeleton w-full h-6 mb-2"></div>
            <div className="skeleton w-full h-6 mb-2"></div>
            <div className="skeleton w-28 h-6 mb-2"></div>
            <div className="flex justify-between items-center">
              <div className="flex gap-2 items-center">
                <div className="skeleton h-10 w-28 !rounded-full"></div>
                <div className="skeleton w-7 h-7"></div>
              </div>
              <div className="skeleton w-20 h-7"></div>
            </div>
          </div>
        </div>
        <div
          key={item}
          className="hidden gap-2 mb-3 w-full max-sm:flex max-sm:items-center max-sm:justify-center max-sm:p-2 py-3 max-sm:border-[#89D9EE] border rounded-xl"
        >
          <div className="skeleton min-w-20 h-20"></div>
          <div className="h-28 w-full py-3">
            <div className="flex gap-2">
              <div className="skeleton w-full h-6 mb-1"></div>
              <div className="skeleton w-6 h-6 mb-1"></div>
            </div>
            <div className="skeleton w-20 h-6 mb-1"></div>
            <div className="flex justify-between items-center">
              <div className="skeleton w-20 h-6"></div>
              <div className="skeleton h-7 w-28 !rounded-full"></div>
            </div>
          </div>
        </div>
      </>
    );
  });
};

export default CheckoutItemSkeleton;
